import { fetchApi } from "../utils/fetchApi";

export function fetchBatterystatus({ filter = {}, options = {} }) {
  return fetchApi({ url: `batterystatus/${filter.vin}`, filter: {}, options });
}

